// import consts from "@/consts"
import {arrayFilter_OnlyUnique, getApiProps} from "@/lib/lib";
import i18n from "@/i18n";

const changedField = 'changed__time';
const alertsTypes = ['alert'];

let _greenseeEventsIndexCache = {arr: null, map: null}
function getGreenseeEventsIndexMap(state) {
    if (_greenseeEventsIndexCache.arr !== state.greenseeEvents) {
        _greenseeEventsIndexCache.map = new Map(state.greenseeEvents.map((e, i) => [e.xid, i]))
        _greenseeEventsIndexCache.arr = state.greenseeEvents
    }
    return _greenseeEventsIndexCache.map
}

export default {
    state: {
        greenseeEvents_index: [],
        greenseeEvents: [],
        greenseeLastVisitEvents: null,
        greenseeLastVisitAlerts: null,
    },
    actions: {
        fetchGreenseeEvents4Date({commit, dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                args = {unitId: '', date: '', ...args}
                if (args.date == 'today' || !args.date) args.date = getters.getDateToday
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !(args.date > '')) {//!args.unitId ||
                    return reject(false)
                }

                if (args.unitId > 0 && !args.force) {
                    let index = getters.getGreenseeEventsIndex.find(i => (i.unitId == args.unitId && i.date == args.date))
                    if (index) {
                        return resolve(true)
                    }
                }

                dispatch('setLastCall', {name: 'fetchGreenseeEvents4Date', args, time: Date.now() / 1000})
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastGreenseeEvents', args, time: Date.now() / 1000})
                    dispatch('setLastCall', {name: 'fetchGreenseeEventsChanged', args, time: Date.now() / 1000})
                }

                let params = getApiProps('greenseeEvents', {withAddress: 1, ...args})
                delete params.unitId;delete params.date;
                this.$api.greenseeEvents.get4Date(args.unitId, args.date, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeGreenseeEvents', response.data)
                            if (!params.limit || response.data.length < params.limit) {
                                commit('setGreenseeEventsIndex', {...args, count: response.data.length})
                                if (!args.unitId && response.data.length) {
                                    response.data
                                        .map(e => e.unit_id)
                                        .filter(arrayFilter_OnlyUnique)
                                        .forEach(unitId => {
                                            commit('setGreenseeEventsIndex', {...args, unitId, count: 1})
                                        })
                                }
                            }
                            resolve(true)
                        } else {
                            reject(response)
                            console.error(response);
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchGreenseeEvents4Date', args, inprogress: false})
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastGreenseeEvents', args, inprogress: false})
                            dispatch('setLastCall', {name: 'fetchGreenseeEventsChanged', args, inprogress: false})
                        }
                    });
            })
        },
        fetchGreenseeEvents4Period({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.from || !args.to) {//!args.unitId ||
                    return reject(false)
                }

                // if (args.unitId > 0 && !args.force) {
                //     let index = getters.getGreenseeEventsIndex.find(i => (i.unitId == args.unitId && i.date == args.date))
                //     if (index) {
                //         return resolve(true)
                //     }
                // }

                dispatch('setLastCall', {name: 'fetchGreenseeEvents4Date', args, time: Date.now() / 1000})
                /* getters.getTimeToday+24h and args.from/to intersect*/
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastGreenseeEvents', args, time: Date.now() / 1000})
                    dispatch('setLastCall', {name: 'fetchGreenseeEventsChanged', args, time: Date.now() / 1000})
                }

                let params = getApiProps('greenseeEvents', {withAddress: 1, ...args})
                delete params.unitId;delete params.from;delete params.to;
                this.$api.greenseeEvents.get4Period(args.unitId, args.from, args.to, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeGreenseeEvents', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                            console.error(response);
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchGreenseeEvents4Date', args, inprogress: false})
                        /* getters.getTimeToday+24h and args.from/to intersect*/
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastGreenseeEvents', args, inprogress: false})
                            dispatch('setLastCall', {name: 'fetchGreenseeEventsChanged', args, inprogress: false})
                        }
                    });
            })
        },

        reloadGreenseeEvents({commit, dispatch}, args) {
            commit('clearGreenseeEvents')
            return dispatch('fetchGreenseeEvents4Date', {date: 'today', ...args})
        },

        //sayHello() {}
    },
    mutations: {
        setGreenseeEventsIndex(state, params) {
            let i = state.greenseeEvents_index.findIndex(i => i.date == params.date && i.unitId == params.unitId)
            if (i < 0) {
                state.greenseeEvents_index.push(Object.freeze({...params}))
            } else {
                state.greenseeEvents_index[i] = Object.freeze({...state.greenseeEvents_index[i], ...params})
            }
        },
        storeGreenseeEvents(state, nGreenseeEvents) {
            if (!state.greenseeEvents.length) {
                state.greenseeEvents = nGreenseeEvents.map(e => Object.freeze(e))
                return true
            }

            const indexByXid = getGreenseeEventsIndexMap(state)

            nGreenseeEvents.forEach(function (nGreenseeEvent) {
                let i = indexByXid.has(nGreenseeEvent.xid) ? indexByXid.get(nGreenseeEvent.xid) : -1
                if (i < 0) {
                    indexByXid.set(nGreenseeEvent.xid, state.greenseeEvents.length)
                    state.greenseeEvents.push(Object.freeze(nGreenseeEvent))
                } else
                if (state.greenseeEvents[i][changedField] != nGreenseeEvent[changedField]) {
                    // updateObjectByDiff(state.greenseeEvents[i], nGreenseeEvent)
                    delete nGreenseeEvent.xid
                    state.greenseeEvents[i] = Object.freeze({...state.greenseeEvents[i], ...nGreenseeEvent})
                }
            })
        },
        clearGreenseeEvents(state, {unitId} = {}) {
            if (unitId) {
                state.greenseeEvents = state.greenseeEvents.filter(e => (e.unit_id || e.object_id) != unitId)
                state.greenseeEvents_index = state.greenseeEvents_index.filter(i => i.unitId != unitId)
            } else {
                state.greenseeEvents = [];
                state.greenseeEvents_index = [];
                state.greenseeLastVisitEvents = null;
                state.greenseeLastVisitAlerts = null;
            }
        },
        setGreenseeLastVisitEvents(state, time) {
            state.greenseeLastVisitEvents = time
        },
        setGreenseeLastVisitAlerts(state, time) {
            state.greenseeLastVisitAlerts = time
        },
    },
    getters: {
        getGreenseeLastVisitEvents(state, getters) {
            return state.greenseeLastVisitEvents || (localStorage.getItem(getters.getUserStorageKey + '.greenseeEvents.lastVisit') * 1)
        },
        getGreenseeLastVisitAlerts(state, getters) {
            return state.greenseeLastVisitAlerts || (localStorage.getItem(getters.getUserStorageKey + '.greenseeAlerts.lastVisit') * 1)
        },
        getGreenseeNewEventsCount(state, getters) {
            let lastVisit = getters.getGreenseeLastVisitEvents
            if (getters.getTimeToday > lastVisit) lastVisit = getters.getTimeToday
            return state.greenseeEvents.filter(e => (e.time?.utc > lastVisit) && !alertsTypes.includes(e['sub-type'])).length
        },
        getGreenseeNewAlertsCount(state, getters) {
            let lastVisit = getters.getGreenseeLastVisitAlerts
            if (getters.getTimeToday > lastVisit) lastVisit = getters.getTimeToday
            let greenseeEvent = state.greenseeEvents.filter(e => (e.time?.utc > lastVisit) && alertsTypes.includes(e['sub-type'])).length
            return greenseeEvent;
        },
        getGreenseeEventsIndex(state) {
            return state.greenseeEvents_index
        },
        getGreenseeEvents(state) {
            return state.greenseeEvents
        },
        getGreenseeEventsI18nMessages(state) {
            return state.greenseeEvents
                .map((greenseeEventsTextByXid, greenseeEvent) => {
                    let message = greenseeEvent?.message?.msg;
                    if (message) {
                        let matches = message.matchAll(/\$t{([\w]+)}/gi);
                        Array.from(matches).forEach(match => {
                            let str = greenseeEvent?.message[match[1]] || ''
                            let translateKey = 'message.' + 'greenseeEvents' + '.' + str
                            str = i18n.global.te(translateKey) ? i18n.global.t(translateKey) : str
                            message = message.replace(match[0], str);
                        })
                    }
                    return {type: greenseeEvent.type, xid: greenseeEvent.xid, message};
                })
        },
        getGreenseeEventsI18nMessagesByXid(state) {
            return state.greenseeEvents
                .reduce((greenseeEventsTextByXid, greenseeEvent) => {
                    let message = greenseeEvent?.message?.msg;
                    if (message) {
                        let matches = message.matchAll(/\$t{([\w]+)}/gi);
                        Array.from(matches).forEach(match => {
                            let str = greenseeEvent?.message[match[1]] || ''
                            let translateKey = 'message.' + 'greenseeEvents' + '.' + str
                            str = i18n.global.te(translateKey) ? i18n.global.t(translateKey) : str
                            message = message.replace(match[0], str);
                        })
                    }
                    greenseeEventsTextByXid[greenseeEvent.xid] = message;// || i18n.global.t('message.Unknown')//???
                    return greenseeEventsTextByXid;
                }, {})
        },
        getGreenseeEventsLastTimeByUnitIds(state) {
            return state.greenseeEvents
                //.filter(e => e?.time?.utc >= getters.getTimeToday)
                .reduce((timeByUnitIds, greenseeEvent) => {
                    timeByUnitIds[greenseeEvent.unit_id] = greenseeEvent?.time?.utc > timeByUnitIds[greenseeEvent.unit_id] ? greenseeEvent?.time?.utc : timeByUnitIds[greenseeEvent.unit_id]
                    return timeByUnitIds
                }, {})
        },
    }
}
